export const phoneValidationAR = [
  {
    required: true,
    message: "من فضلك ادخل رقم الهاتف",
  },
  // {type: 'number'},
  {
    min: 8,
    message: "يجب أن يتكون الهاتف من 8 أرقام على الأقل",
  },
  {
    max: 11,
    message : "لا يمكن أن يكون الهاتف أطول من 11 رقمًا"
  },
  { 
    pattern: /^[0-9\b]+$/,
    message: "يجب ان يحتوي رقم الهاتف علي ارقام فقط",
  },
];

export const phoneValidationEN = [
  {
    required: true,
    message: "Please enter the phone number",
  },
  // {type: 'number'},
  {
    min: 8,
    message: "The phone must consist of at least 8 numbers",
  },
  {
    max: 11,
    message : "The phone cannot be longer than 11 digits"
  },
  {
    pattern: /^[0-9\b]+$/,
    message: "The phone number must contain only numbers.",
  },
];
  
export const codeValidation = [
    {
      required: true,
      message: "Please enter code number", 
    },
    {
      len: 4,
       message: "code must be exactly 4 digits ",
    },
    {
      pattern: /^[0-9\b]+$/,
      message: "code must contain numbers only",
    },
  ];

export const codeValidationAr = [
    {
      required: true,
      message: "من فضلك ادخل رقم الرمز", 
    },
    {
      len: 4,
       message: "يجب أن يتكون الرمز من 4 أرقام بالضبط",
    },
    {
      pattern: /^[0-9\b]+$/,
      message: "يجب ان يحتوي الرمز علي ارقام فقط",
    },
  ];






export const fallbackImg = "data:image/png;base64,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"

export const addressGif = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAADEklEQVRoge2ZO2gUURSGvwQTMbIRV5D4wCoqxsZKIwYLWRtFAxqDhRorO9F01oFUgpUkphARRGIl4gOiIRoFQdxCCahREWW10KjR4AvMw+LeceM6O3PunZk7W+SHQ5bN+c/9/72PPXMX5lBZqEqg5jqgFcgBK3UAFIB3wC3gCvAsgbFjwUZgCJgRxn2gJRWlZVAL9AHTyE14MQ306hqpYglwF3MDpTEMZB1r/4sa4HaIQJO4R0oz02chNix6nDpAbWybPSHZM80OfXAnARNeDLky0ZSgCS/WmoqqtjCyW5j3FtgH1OvYC7wQclstdBljkPBPtID/cZpFGQzj30zUgcaoQEhbAL9dwHfSvkwIhGQC+IsE/AlTUTZ7ZJ4gJ2ozKhnjH9gY+SzIyQX8b7uA/1GoJRIkHe4oqg8rRRZ1coXxB01F2czII0HOGuAxamN7x28b8ABojGmMyNhF8l+IO1wYWQj8StDED6DOVJTN0voO3LDgSXENZcYJ9pDcjDhpTzzUAG8SMFHQtY1hs7QAfgOnLblBOKVrO0U98IX4ZuMrqn2xgu2MgOqHzkbgl+IMykwqWIE6xaLOxjdgmWPt/6Gb6Ea6nKv2QQZ4j72JMdR+qwgcw97I0RT0lkUt8BRzE09wcClXBbwKETIFbNL5WzG765oGtmmupBF9jeUDW4tQUJ7iMX7BwMh5zZkPPBdyttgY6dHkbgNOAzAuEPQJWGpQ95zm9RpwANXvjGnyekPuYcKNHDCsmaP4ARjtKW/N5g0H9HCZ8iauWtSrRjWUM1qbGP2a1GkxKMBy1CWF35Ky/QY/qWv0SwkZVNsxhWpBbOH3zNIeod4GXeMnwuayQxMGIgzqYfZvKMYb1QcjulaHJHlAJx+KYeA6PfgIsCCGeidQ2kLvhhuASdTSCrr2NEEjsisgCVahlvwkIXutE+X4YkwDJ4FhlMbjQUl5nbTThSJLHEFpfFguYbVO+IDlBYAjLKZ4r9bkvTn7Ufeg/nuJFC4ADDAOXNev9/slSBu3SoqXlHTEzRUgyjY2+83KHNLGH6YJtWgqN80lAAAAAElFTkSuQmCC"